export const ARTIFACTS_API_TAGS = {
  ARTIFACT_TAG: 'Artifact',
};
